// CHG-1649 / ITER-3758 — route-scoped wrapper for WelcomeTrigger.
//
// The CHG-1283 welcome overlay is intentionally a landing-page
// experience. v2 has three "landing" routes (the post-login entry
// points for each role):
//
//   "/"           — Overview (default authenticated landing per CHG-1538
//                   RoleAwareRedirect logic; also the safety net for
//                   neither-role accounts)
//   "/overview"   — Overview (canonical org admin home per CHG-1540)
//   "/platform"   — PlatformDashboard (platform admin home per CHG-1540)
//   "/me"         — MyOverview (donor-only home per CHG-1502 γ.3)
//
// Mounting WelcomeTrigger only on these routes (rather than at App.tsx
// root for every route) means:
//
//   1. Deep-link visits to /donors, /campaigns, /stripe-accounts, etc.
//      never have the welcome modal in their DOM tree at all — even
//      if the dismissed flag fails to persist for any reason (private-
//      mode storage, brand-variant hostname switch, etc.), the modal
//      can't appear on non-landing surfaces.
//   2. The WelcomeTrigger component still mounts ONCE per visit to a
//      landing route, so its lazy useState initializer + useLayoutEffect
//      run synchronously at first render and the dismissed flag is
//      checked pre-paint.
//   3. Re-mount on navigation back to a landing route is safe — the
//      lazy initializer re-reads localStorage and respects the flag.
//
// Per the P0 brief v3 field-test report: the regression returning
// after CHG-1469 was a flash-window symptom; route-scoping is the
// belt-and-suspenders containment so even if the flash returns later
// it can never appear on a non-landing surface.

import { useLocation } from "react-router-dom";
import { WelcomeTrigger } from "./WelcomeTrigger";

const MOUNT_PATHS = new Set(["/", "/overview", "/platform", "/me"]);

export function isWelcomeMountPath(pathname: string): boolean {
  return MOUNT_PATHS.has(pathname);
}

export function WelcomeMount() {
  const location = useLocation();
  if (!isWelcomeMountPath(location.pathname)) return null;
  return <WelcomeTrigger />;
}
